__turbopack_context__.v({
  "livestream_hero": "Hk6U1q_livestream_hero",
  "livestream_hero_background_fallback": "Hk6U1q_livestream_hero_background_fallback",
  "livestream_hero_background_image": "Hk6U1q_livestream_hero_background_image",
  "livestream_hero_buttons": "Hk6U1q_livestream_hero_buttons",
  "livestream_hero_kabob_button_above_sm": "Hk6U1q_livestream_hero_kabob_button_above_sm",
  "livestream_hero_kabob_button_below_sm": "Hk6U1q_livestream_hero_kabob_button_below_sm",
  "livestream_hero_kabob_content_above_sm": "Hk6U1q_livestream_hero_kabob_content_above_sm",
  "livestream_hero_kabob_content_below_sm": "Hk6U1q_livestream_hero_kabob_content_below_sm",
  "livestream_hero_kabob_item_link": "Hk6U1q_livestream_hero_kabob_item_link",
  "livestream_hero_kabob_item_watch_live": "Hk6U1q_livestream_hero_kabob_item_watch_live",
  "livestream_hero_live_badge": "Hk6U1q_livestream_hero_live_badge",
  "livestream_hero_livestream_title": "Hk6U1q_livestream_hero_livestream_title",
  "livestream_hero_overlay": "Hk6U1q_livestream_hero_overlay",
  "livestream_hero_show_description": "Hk6U1q_livestream_hero_show_description",
  "livestream_hero_show_title_logo": "Hk6U1q_livestream_hero_show_title_logo",
});
